import { env } from '@sib/config';
import { LOGIN_BASE_REQUEST } from './constants';
import { msalInstance } from './msal-instance';

const redirectUri = env.isExtension
  ? `https://${chrome?.runtime?.id}.chromiumapp.org`
  : '';

let tokenUrl: string | null = null;
/**
 * Generates a login url
 */
async function acquireTokenUrl() {
  await msalInstance.handleRedirectPromise();

  return new Promise<string>(resolve => {
    if (tokenUrl) {
      resolve(tokenUrl);

      return;
    }

    msalInstance.acquireTokenRedirect({
      ...LOGIN_BASE_REQUEST,
      redirectUri,
      prompt: 'none',
      onRedirectNavigate: url => {
        tokenUrl = url;
        resolve(url);

        return false;
      },
    });
  });
}

/**
 * Generates a login url
 */
async function launchWebAuthFlow(url: string, interactive = true) {
  const responseUrl = await chrome.identity.launchWebAuthFlow({
    interactive,
    url,
  });

  if (responseUrl?.includes('#')) {
    const data = await msalInstance.handleRedirectPromise(
      `#${responseUrl.split('#')[1]}`
    );

    return data;
  }

  return null;
}

export const getExtensionTokenFallback = async () => {
  if (!env.isExtension) return null;

  try {
    const url = await acquireTokenUrl();
    tokenUrl = null;

    return await launchWebAuthFlow(url);
  } catch {
    return null;
  }
};

let loginUrl: string | null = null;

/**
 * Generates a login url
 */
export async function getLoginUrl() {
  return new Promise<string>(resolve => {
    if (loginUrl) {
      resolve(loginUrl);

      return;
    }

    msalInstance.loginRedirect({
      ...LOGIN_BASE_REQUEST,
      redirectUri,

      prompt: 'select_account',
      onRedirectNavigate: url => {
        loginUrl = url;
        resolve(url);

        return false;
      },
    });
  });
}

export const loginAction = async () => {
  const loginUrl = await getLoginUrl();

  const result = await launchWebAuthFlow(loginUrl);

  if (!result) throw new Error('Login failed');

  msalInstance.setActiveAccount(result.account);

  return result;
};
